export const generateRandomString: () => string = () =>
  (Math.random() + 1).toString(36).substring(9);
